import styled from "@emotion/styled";
import { systemWidth } from "@kaltura/mediaspace-shared-styled";
import { AdImages as SharedAdImages, AdImagesProps } from "@kaltura/mediaspace-shared-ui";

const StyledAdImages = styled("div")(systemWidth);

/**
 * AdImages Component displays two AD images with links - in home component context
 */
export function AdImages(props: AdImagesProps) {
    const baseClass = "kms-ds-homepage-component";

    return (
        <StyledAdImages className={baseClass + "-ad-images"}>
            <SharedAdImages {...props} baseClass={baseClass} />
        </StyledAdImages>
    );
}

export default AdImages;
